import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const InstagramWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 38 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          d="M14.75 18a3.25 3.25 0 0 1 6.271-1.263 3.25 3.25 0 0 1-5.296 3.52A3.25 3.25 0 0 1 14.75 18Zm-1.757 0a5.007 5.007 0 1 0 10.014 0 5.007 5.007 0 0 0-10.014 0Zm9.042-5.204a1.17 1.17 0 1 0 2.34 0 1.17 1.17 0 0 0-2.34 0Zm-7.974 13.14c-.95-.045-1.467-.203-1.81-.336a3.03 3.03 0 0 1-1.121-.73 3.033 3.033 0 0 1-.731-1.121c-.133-.343-.292-.86-.334-1.81-.049-1.027-.058-1.337-.058-3.94 0-2.603.011-2.912.058-3.94.042-.951.202-1.467.335-1.811.177-.455.389-.78.729-1.122.34-.341.665-.552 1.12-.729.345-.134.861-.292 1.812-.335 1.029-.048 1.337-.057 3.939-.057 2.602 0 2.913.01 3.94.057.95.043 1.468.203 1.811.335.456.177.78.388 1.121.73.342.34.553.666.73 1.12.135.344.293.86.336 1.812.047 1.028.056 1.337.056 3.94 0 2.603-.009 2.911-.056 3.94-.044.95-.203 1.467-.335 1.811a3.04 3.04 0 0 1-.73 1.121 3.042 3.042 0 0 1-1.122.73c-.343.133-.86.292-1.81.334-1.028.048-1.336.056-3.941.056-2.604 0-2.912-.008-3.939-.056Zm-.08-17.628c-1.039.05-1.748.213-2.367.454a4.773 4.773 0 0 0-1.727 1.125 4.763 4.763 0 0 0-1.125 1.727c-.241.619-.406 1.328-.454 2.367-.046 1.04-.058 1.37-.058 4.019 0 2.648.011 2.98.059 4.02.048 1.038.212 1.746.453 2.366a4.762 4.762 0 0 0 1.125 1.727 4.794 4.794 0 0 0 1.727 1.125c.621.241 1.328.406 2.367.454 1.04.046 1.372.058 4.019.058 2.647 0 2.981-.011 4.02-.058 1.038-.05 1.747-.213 2.367-.454a4.787 4.787 0 0 0 1.727-1.125 4.776 4.776 0 0 0 1.125-1.727c.24-.62.406-1.328.453-2.367.047-1.04.058-1.372.058-4.019 0-2.647-.011-2.98-.058-4.02-.048-1.038-.213-1.747-.453-2.366a4.803 4.803 0 0 0-1.125-1.727 4.756 4.756 0 0 0-1.728-1.125c-.619-.241-1.327-.406-2.364-.454-1.04-.046-1.372-.058-4.02-.058-2.65 0-2.98.011-4.021.059Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_112950" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_112950" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
